<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        优惠券明细
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px ;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
        border
        style="width: 100%"
        ref="multipleTable"
        :data="tableData"
      >
        <el-table-column prop="name" width="310" label="名称" align="center"></el-table-column>
        <el-table-column prop="type" label="优惠券类型" align="center"></el-table-column>
        <el-table-column prop label="可使用商品" align="center"></el-table-column>

        <el-table-column prop="sill" label="使用门槛" align="center"></el-table-column>
        <el-table-column prop="money" label="面值" align="center"></el-table-column>

        <el-table-column prop="status" label="状态" align="center"></el-table-column>
      </el-table>

      <el-table
        :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
        :data="tableData"
        border
        style="width: 100%"
        ref="multipleTable"
      >
        <el-table-column prop="end_date1" width="310" label="有效期" align="center"></el-table-column>
        <el-table-column prop="number" label="总发行量" align="center"></el-table-column>
        <el-table-column prop="use_number" label="已领取" align="center"></el-table-column>
        <el-table-column prop="receive" label="待领取" align="center"></el-table-column>
        <el-table-column prop="use" label="已使用" align="center"></el-table-column>
        <el-table-column prop="no_use" label="未使用" align="center"></el-table-column>
      </el-table>

      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="4">
            <div class="label">使用状态:</div>
          </el-col>
          <el-col :span="6">
            <template>
              <el-select learable v-model="value1" size="small" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-col>

          <el-col :span="14" align="center">
            <div class="filtrate_seek_sousuo" @click="special()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
        :data="tableData1"
        border
        style="width: 100%"
        ref="multipleTable"
      >
        <el-table-column prop="nickname" label="会员名称" align="center"></el-table-column>
        <el-table-column prop="bind_mobile" label="会员账号" align="center"></el-table-column>
        <el-table-column label="领取方式" prop="draw_type" align="center"></el-table-column>

        <el-table-column prop="create_date" width="160" label="领取时间" align="center"></el-table-column>
        <el-table-column prop="status" label="当前状态" align="center"></el-table-column>
        <el-table-column prop="order_time" label="使用时间" align="center" width="160"></el-table-column>
        <el-table-column width="200" prop="orderCode" label="订单编号" align="center"></el-table-column>
      </el-table>
      <div class="pager">
        <el-row style="text-align:center">
          <!--  -->
          <el-col :span="3">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="5"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      options: [
        {
          label: "未使用",
          value: 1
        },
        {
          label: "已使用",
          value: 2
        },
        {
          label: "已过期",
          value: 3
        }
      ],
      value1: "",
      id: this.$route.params.id,
      value: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      tableData1: []
    };
  },
  created() {
    this.$store.state.leftTitle = "优惠券列表";
    this.$store.state.topActiveId = 5;
    this.geting();
    this.special();
  },

  methods: {
    setPage(v) {
      //分页

      this.page = v;
      this.special(v);
      this.selectAll = false;
    },
    geting() {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/coupons_detail", {
          params: {
            token: this.token,
            username: this.username,
            coupons_id: this.id
          }
        })
        .then(res => {
          var json = res.data.data;
          var time = json.end_date;
          var timeNew = new Date(parseInt(time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
          json.end_date1 = timeNew;

          var begain_date = new Date(parseInt(json.begain_date) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
          if (json.type == 0) {
            json.type = "通用优惠券";
          }
          if (json.type == 1) {
            json.type = "部分分类";
          }
          if (json.type == 2) {
            json.type = "部分商品";
          }
          if (json.type == 3) {
            json.type = "部分品牌";
          }
          json.sill = "￥" + json.sill;
          json.money = "￥" + json.money;
          json.receive = json.number - json.use_number;
          json.end_date1 = begain_date + "至" + " " + timeNew;
          that.tableData.push(json);
          var timestamp = Date.parse(new Date()) / 1000;
          if (timestamp >= json.end_date) {
            json.status = "已过期";
          } else {
            json.status = "未过期";
          }
        });
    },
    special(page) {
      this.axios
        .get(this.serve+"/admin/coupons_use_log", {
          params: {
            username: this.username,
            token: this.token,
            coupons_id: this.id,
            status: this.value1,
            page
          }
        })
        .then(res => {
          this.tableData1 = [];
          this.page = res.data.page;
          this.total = res.data.total;
          var json = res.data.results;
          for (var key in json) {
            if (json[key].stale_dated == "1") {
              json[key].status = "已过期";
            }
            if (json[key].stale_dated == "0") {
              if (json[key].is_use == "0") {
                json[key].status = "未使用";
              }
              if (json[key].is_use == "1") {
                json[key].status = "已使用";
              }
            }
            if (json[key].order_time != null) {
              var time = json[key].order_time;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json[key].order_time = timeNew;
            }
            if (json[key].draw_type == "0") {
              json[key].draw_type = "测试";
            }
            if (json[key].draw_type == "1") {
              json[key].draw_type = "领取";
            }
            if (json[key].draw_type == "2") {
              json[key].draw_type = "后台发放";
            }
            if (json[key].draw_type == "3") {
              json[key].draw_type = "购物赠送";
            }
            var create_date = new Date(parseInt(json[key].create_date) * 1000)
              .toLocaleString()
              .replace(/:\d{1,2}$/, " ");
            json[key].create_date = create_date;
            this.tableData1.push(json[key]);
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .form-title {
    margin-top: 30px;
  }
  .is-background {
    text-align: center;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>